import init from '../gas/init'

init()
